// "example.com/page" -> "https://example.com/page". Blank stays blank, and a
// link that already says how to open it (https://, mailto:, tel:) is kept.
export const withHttps = (link) => {
  const value = String(link || "").trim();
  if (!value) return "";
  return /^[a-z][a-z0-9+.-]*:/i.test(value) ? value : `https://${value.replace(/^\/+/, "")}`;
};
